import { Modal } from "antd";
import React, { useEffect } from "react";
import "./ConnectDialog.css";
import Web3 from "web3";
import WalletConnectProvider from '@walletconnect/web3-provider';
import Web3Modal from "web3modal";

const ConnectDialog = ({ modalVisible, showConnectDialog, setLogged, toggleWalletDialog, getAccountAndBalance }) => {



  const connectToWallet = async () => {
    alert('We are working on it!')
  }

  const connectToFormatic = async () => {
  }

  const connectToWalletFun = async () => {
    console.log("testing");
    debugger;
    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       rpc: {
    //         NETWORKID: "https://data-seed-prebsc-1-s1.binance.org:8545"
    //       },
    //       network: "bsc"
    //     }
    //   }
    // };

    // const web3Modal = new Web3Modal({
    //   cacheProvider: true, // optional
    //   providerOptions
    // });

    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       infuraId: '3372eec218054d8280084d9691432b04' // required
    //     }
    //   }
    // };

    //ROPSTON
    // const providerOptions = {
    //   walletconnect: {
    //     package: WalletConnectProvider, // required
    //     options: {
    //       infuraId: "3372eec218054d8280084d9691432b04" // required
    //     }
    //   }
    // };

    //BSC
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          rpc: {
            NETWORKID: "https://bsc-dataseed1.binance.org:443"
          },
          network: "bsc"
        }
      }
    };

    const web3Modal = new Web3Modal({
      // network: 'ropsten', // optional
      cacheProvider: true, // optional
      providerOptions
    });

    const provider = await web3Modal.connect();
    const web3js = new Web3(provider); // create web3 instance
    const accounts = await web3js.eth.getAccounts();
    console.log(`accounts ===> `, accounts)
    // accountStatusSource.next(accounts);
    const balance = await web3js.eth.getBalance(accounts[0]);
    // You can use balance here
    // this.totalEtheriumBalance = balance / 1e18;
    // await window.ethereum.enable();

    showConnectDialog();
    setLogged(true);
    getAccountAndBalance(accounts[0], balance / 1e18)

    console.log(`balance ====> `, balance);
    provider.on("accountsChanged", (accounts) => {
      console.log("accountsChanged ====> ", accounts);
    });

    // Subscribe to chainId change
    provider.on("chainChanged", (chainId) => {
      console.log("chainId ====> ", chainId);
    });

    // Subscribe to provider connection
    provider.on("connect", (info) => {
      console.log("info===", info);
    });

    // Subscribe to provider disconnection
    provider.on("disconnect", (error) => {
      console.log("disconnect===>", error);
    });

  }

  return (
    <div>
      <Modal
        width={window.screen.width > 500 ? "30vw" : "90vw"}
        mask={true}
        style={{ top: 15 }}
        maskStyle={{ background: "rgba(0, 0, 0, .8)" }}
        title="Connect"
        visible={modalVisible}
        onOk={showConnectDialog}
        onCancel={showConnectDialog}
        footer={[]}
      >
        <div className="connect-dialog">
          {/* <img
            className="connect-main-image"
            src="https://i.pinimg.com/originals/d5/c8/7c/d5c87c9160550d386791069339bbd762.jpg"
            alt="connect wallet background"
          /> */}
          <div className="connect-container">
            <h1>Connect your wallet</h1>
            <h3>
              Connect with one of available wallet providers or create a new
              wallet.
              <span onClick={toggleWalletDialog} > What is wallet?</span>
            </h3>
            <div className="connect-item-container">
              <div className="connect-item" onClick={connectToWalletFun}>
                <img
                  src="https://rarible.com/static/c879a582a94e772b8ed27295ae83145d.svg"
                  alt="metamask"
                />
                <h2>Metamask</h2>
              </div>
              <div className="connect-item" onClick={connectToWallet}>
                <img
                  src="https://rarible.com/static/e7fbb606805f82bd7a35aba13f77dbce.svg"
                  alt="metamask"
                />
                <h2>Fortmatic</h2>
              </div>
              <div className="connect-item" onClick={connectToWalletFun}>
                <img
                  src="https://rarible.com/static/33e41e4b40136207f4a535b5850d1faa.svg"
                  alt="metamask"
                />
                <h2>WalletConnect</h2>
              </div>
              <div className="connect-item" onClick={connectToWallet}>
                <img
                  src="https://rarible.com/static/5b5a2db80207ba34ca3ce271d20af421.svg"
                  alt="metamask"
                />
                <h2>Coinbase Wallet</h2>
              </div>
              <div className="connect-item" onClick={connectToWallet}>
                <img
                  src="https://rarible.com/static/e6acd346113bb2a37dd71732eacd34ed.svg"
                  alt="metamask"
                />
                <h2>MyEtherWallet</h2>
              </div>
              <div className="connect-item" onClick={connectToWallet}>
                <img
                  src="https://rarible.com/static/81cb7a45a085a8b5a19791dfb05468fa.svg"
                  alt="metamask"
                />
                <h2>Torus</h2>
              </div>
            </div>
            <h3>We do not own your private keys and cannot access your funds without your confirmation.</h3>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ConnectDialog;
